module.exports = __webpack_public_path__ + "static/media/footer-logo.539a32e8.png";